import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import IntlMessages from "@util/IntlMessages";
import { getListStructure } from "../../../../services/api/Api";
import { Message, Switch, Button, Spin, Input } from "../../../BP2Components";
import "./CalendarSettings.less";

const { Option } = Select;

const CalendarSettings = ({ value }) => {
   const dispatch = useDispatch();
   const [settings, setSettings] = useState({
      ...value
   });
   const [listColumns, setListColumns] = useState([]);

   const handleChangeInput = (name) => (e) => {
      setSettings({ ...settings, [name]: +e.target.value });
   };

   const handleColumnLabelChange = (name) => (value) => {
      setSettings({ ...settings, calendarColumns: { ...settings.calendarColumns, [name]: value } });
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      dispatch(setWidgetInSheetParams(settings));
      Message.success(<IntlMessages id="save.modal" />);
   };

   const handleSwitch = (checked, name) => {
      setSettings({ ...settings, [name]: checked });
   };

   useEffect(() => {
      if (settings.calendarId) {
         getListStructure(settings.calendarId).then((res) => {
            const responseData = res.data.getStructure;
            const { columns } = responseData;
            setListColumns(columns.map((column) => column.label));
         });
      }
   }, [settings.calendarId]);

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label key="content" className="widget-settings__inner__label">
                     <IntlMessages id="settings.calendarId" />:
                     <Input
                        type="number"
                        name="calendarId"
                        placeholder="Numbers only"
                        style={{ width: "250px" }}
                        onChange={handleChangeInput("calendarId")}
                        defaultValue={value?.calendarId}
                     />
                  </label>
                  <label key="showNewEventButton" className="widget-settings__inner__label">
                     <IntlMessages id="settings.showNewEventButton" />:
                     <Switch
                        autoSize={{ minRows: 3, maxRows: 15 }}
                        name="showNewEventButton"
                        onChange={(e) => handleSwitch(e, "showNewEventButton")}
                        defaultChecked={value?.showNewEventButton}
                     />
                  </label>
                  <label key="aspectRatio" className="widget-settings__inner__label">
                     <IntlMessages id="settings.aspectRatio" />:
                     <Input
                        type="number"
                        name="aspectRatio"
                        placeholder="Numbers only"
                        style={{ width: "250px" }}
                        onChange={handleChangeInput("aspectRatio")}
                        defaultValue={value?.aspectRatio ? value.aspectRatio : 1.8}
                     />
                  </label>

                  <p style={{ textAlign: "center" }}>
                     <IntlMessages id="calendar.labelSettings" />
                  </p>

                  {!settings.calendarId ? (
                     <IntlMessages id="calendar.noCalendarId" />
                  ) : !listColumns.length ? (
                     <div className="spin-middle">
                        <Spin />
                     </div>
                  ) : (
                     <div className="column-label-selects">
                        <label className="widget-settings__inner__label" key="idColumnLabel">
                           <IntlMessages id="settings.idColumnLabel" />:
                           <Select
                              onSelect={handleColumnLabelChange("eventId")}
                              defaultValue={settings.calendarColumns?.eventId}
                           >
                              {listColumns.map((column) => (
                                 <Option key={column} value={column}>
                                    {column}
                                 </Option>
                              ))}
                           </Select>
                        </label>
                        <label className="widget-settings__inner__label" key="titleColumnLabel">
                           <IntlMessages id="settings.titleColumnLabel" />:
                           <Select
                              onSelect={handleColumnLabelChange("title")}
                              defaultValue={settings.calendarColumns?.title}
                           >
                              {listColumns.map((column) => (
                                 <Option key={column} value={column}>
                                    {column}
                                 </Option>
                              ))}
                           </Select>
                        </label>
                        <label className="widget-settings__inner__label" key="startDateColumnLabel">
                           <IntlMessages id="settings.startDateColumnLabel" />:
                           <Select
                              onSelect={handleColumnLabelChange("startDate")}
                              defaultValue={settings.calendarColumns?.startDate}
                           >
                              {listColumns.map((column) => (
                                 <Option key={column} value={column}>
                                    {column}
                                 </Option>
                              ))}
                           </Select>
                        </label>
                        <label className="widget-settings__inner__label" key="endDateColumnLabel">
                           <IntlMessages id="settings.endDateColumnLabel" />:
                           <Select
                              onSelect={handleColumnLabelChange("endDate")}
                              defaultValue={settings.calendarColumns?.endDate}
                           >
                              {listColumns.map((column) => (
                                 <Option key={column} value={column}>
                                    {column}
                                 </Option>
                              ))}
                           </Select>
                        </label>
                        <label className="widget-settings__inner__label" key="startHourColumnLabel">
                           <IntlMessages id="settings.startHourColumnLabel" />:
                           <Select
                              onSelect={handleColumnLabelChange("startHour")}
                              defaultValue={settings.calendarColumns?.startHour}
                           >
                              {listColumns.map((column) => (
                                 <Option key={column} value={column}>
                                    {column}
                                 </Option>
                              ))}
                           </Select>
                        </label>
                        <label className="widget-settings__inner__label" key="endHourColumnLabel">
                           <IntlMessages id="settings.endHourColumnLabel" />:
                           <Select
                              onSelect={handleColumnLabelChange("endHour")}
                              defaultValue={settings.calendarColumns?.endHour}
                           >
                              {listColumns.map((column) => (
                                 <Option key={column} value={column}>
                                    {column}
                                 </Option>
                              ))}
                           </Select>
                        </label>
                        <label className="widget-settings__inner__label" key="allDayColumnLabel">
                           <IntlMessages id="settings.allDayColumnLabel" />:
                           <Select
                              onSelect={handleColumnLabelChange("allDay")}
                              defaultValue={settings.calendarColumns?.allDay}
                           >
                              {listColumns.map((column) => (
                                 <Option key={column} value={column}>
                                    {column}
                                 </Option>
                              ))}
                           </Select>
                        </label>
                     </div>
                  )}
               </div>
               <Button
                  key="btn"
                  buttonType="primary"
                  htmlType="submit"
                  className="calendar-save-btn"
               >
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};

export default CalendarSettings;
